<template>
  <div class="payment__actions">
    <el-checkbox v-model="isSendReceipt" class="payment__checkbox">
      Получить квитанцию
    </el-checkbox>
    <el-button type="success" class="payment__button" @click="paymentHandler">
      Оплатить
    </el-button>
    <p class="payment__agreement">
      Нажимая кнопку. вы соглашаетесь с
      <router-link to="/">условиями использования сервиса</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Actions',
  data: () => ({
    isSendReceipt: false
  }),

  methods: {
    paymentHandler() {
      this.$router.push({
        name: 'Home',
        query: {
          payment: 'success'
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.payment {
  &__agreement {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: $deepdark;

    a {
      color: $luchmara;
      text-decoration: underline;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    max-width: 332px;

    @include md-and-down {
      margin-top: 36px;
    }

    @include sm-and-down {
      max-width: 100%;
    }
  }

  &__button {
    margin: 24px 0;

    @include sm-and-down {
      width: 100%;
    }
  }

  &__checkbox::v-deep {
    .el-checkbox__label {
      font-size: 15px;
      color: $deepdark;
      font-weight: normal;
    }
  }
}
</style>
